import React, { useState } from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { DisplayClickAndInfoContent } from "./DisplayClickAndInfoContent";
import { PositionedButton } from "./PositionedButton";
import { ReactComponent as SketchIconSvg } from "./click-and-info-icon.svg";
import { CSS_MQ } from "../../styles/breakpoints";
import { TwoColumnGrid } from "../_shared-components/arrangement/TwoColumnGrid";
import { ProductClickAndInfoBackground } from "./elements/ProductClickAndInfoBackground";
import { ContentfulComponentCMSHook } from "@swo/shared";
import { ContentfulImage } from "../_shared-components/image-related/ContentfulImage";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";
import { ProductClickAndInfoType } from "@swo/storefront";
import { mathRound } from "../../utils/js/missing-js-parts";

export const ProductClickAndInfoComponent: ReactTFC<ProductClickAndInfoType & ContentfulComponentCMSHook> = props => {
  const [activeIdx, setActiveIdx] = useState(0);

  const onHotspotClicked = (idx: number) => {
    setActiveIdx(idx);
  };

  const onNavigationRequested = (direction: "back" | "forward") => {
    const numericDirection = direction == "back" ? -1 : 1;

    setActiveIdx(currentIndex => {
      return (currentIndex + numericDirection + props.hotSpotsCollection.length) % props.hotSpotsCollection.length;
    });
  };

  return (
    <ProductClickAndInfoBackground backgroundColor={props.backgroundColor}>
      <TwoColumnGrid
        ratio={["--left", "--right"]}
        columnGap={20}
        container={"--max-content-width-new"}
        atLeast={"md"}
        className={getComponentCMSClassname(props?.sys?.id)}
      >
        <DisplayClickAndInfoContent
          translations={props.translations}
          hotSpots={props.hotSpotsCollection}
          activeIdx={activeIdx}
          onNavigationRequested={onNavigationRequested}
        />

        <div
          css={css`
            // justify-content: center;
            // display: inline-flex;

            width: 100%;

            display: flex;
            align-items: center;
            justify-content: center;

            ${CSS_MQ.atMostSm} {
              display: none;
            }
          `}
        >
          <div
            css={css`
              position: relative;

              @media (pointer: coarse) {
                --size: 40px;
              }

              @media (pointer: fine) {
                --size: 35px;
              }
            `}
          >
            <ContentfulImage
              assetId={props.productImage.sys.id}
              css={css`
                height: 100%;
                width: 100%;
                object-fit: contain;
              `}
              attachPictureStyles={css`
                display: flex;
              `}
              contentfulLink={{
                url: props.productImage.url,
                noTransparentBackground: false,
                requestedWidth: 800,
              }}
              higherDPI={[1.5, 2, 3]}
              alt={props.productImage.description || undefined}
            />

            {props.hotSpotsCollection.map((hotspot, idx) => {
              return (
                <PositionedButton
                  key={idx}
                  className={idx === activeIdx ? "active" : "inactive"}
                  onClick={() => onHotspotClicked(idx)}
                  css={css`
                    --x: ${mathRound(hotspot.hotSpotXPosition * 100, 1)}%;
                    --y: ${mathRound(hotspot.hotSpotYPosition * 100, 1)}%;
                  `}
                >
                  <SketchIconSvg
                    css={css`
                      .active & {
                        color: ${CSS_COLORS.White};
                      }

                      .inactive & {
                        color: ${CSS_COLORS.Green};
                      }
                    `}
                  />
                </PositionedButton>
              );
            })}
          </div>
        </div>
      </TwoColumnGrid>
    </ProductClickAndInfoBackground>
  );
};
